const baseUri = 'me';

export default {
  show() {
    return api.get(baseUri);
  },

  update(data) {
    return api.patch(baseUri, data);
  },
};



// WEBPACK FOOTER //
// ./src/js/api/me.js